import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import * as lookupsActions from './lookups.actions';
import { LookupApiService } from '@wdx/clmi/api-services/services';

@Injectable()
export class LookupsEffects {
    private actions$ = inject(Actions);
    private lookupApiService = inject(LookupApiService);

    getLookup$ = createEffect(() =>
        this.actions$.pipe(
            ofType(lookupsActions.getLookup),
            switchMap((action) =>
                this.lookupApiService
                    .getLookup(
                        action.lookupSource,
                        action.searchText,
                        action.entityId,
                        action.entityType,
                    )
                    .pipe(
                        map((results) =>
                            lookupsActions.getLookupSuccess({
                                lookupId: action.lookupId,
                                results,
                            }),
                        ),
                        catchError((error) =>
                            of(
                                lookupsActions.getLookupFailure({
                                    lookupId: action.lookupId,
                                    error,
                                }),
                            ),
                        ),
                    ),
            ),
        ),
    );

    getContextualLookup$ = createEffect(() =>
        this.actions$.pipe(
            ofType(lookupsActions.getContextualLookup),
            switchMap((action) =>
                this.lookupApiService
                    .getContextualLookup(
                        action.lookupSource,
                        action.lookups,
                        action.searchText,
                        action.context,
                    )
                    .pipe(
                        map((results) =>
                            lookupsActions.getContextualLookupSuccess({
                                lookupId: action.lookupId,
                                results,
                            }),
                        ),
                        catchError((error) =>
                            of(
                                lookupsActions.getContextualLookupFailure({
                                    lookupId: action.lookupId,
                                    error,
                                }),
                            ),
                        ),
                    ),
            ),
        ),
    );
}
